module.exports = __webpack_public_path__ + "img/logo.026488b0.png";